<script>
  import IconButton from './IconButton.svelte';
  import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
</script>

<IconButton title="Delete" on:click icon={faTrashAlt} />